import { render, staticRenderFns } from "./dragger.vue?vue&type=template&id=23027646&scoped=true&lang=html"
import script from "./dragger.vue?vue&type=script&lang=js"
export * from "./dragger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23027646",
  null
  
)

export default component.exports